var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_ESTABLISHMENTS) &&
    _vm.establishment &&
    _vm.establishment.id
  )?_c('div',[_c('router-link',{attrs:{"to":{ name: 'View Establishment', params: { id: _vm.establishment.id } }}},[_vm._v(" "+_vm._s(`${_vm.establishment.company_name}`)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }